"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerUsers = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
const getCustomerUsersBase = (0, sonar_http_1.createGetEndpoint)((_a) => {
    var { customerId, shardName } = _a, rest = __rest(_a, ["customerId", "shardName"]);
    return `/api/v3/core/customers/${customerId !== null && customerId !== void 0 ? customerId : 'current'}/users?${(0, sonar_http_1.getQueryString)(rest)}`;
}, {
    headers: ({ shardName }) => {
        if (shardName) {
            return { [sonar_http_1.HttpHeader.Shard]: shardName };
        }
        return {};
    }
});
const getCustomerUsers = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield getCustomerUsersBase(request);
    if (!response.data) {
        return response;
    }
    const users = response.data.results.map((user) => (Object.assign(Object.assign({}, user), { fullName: `${user.firstName} ${user.lastName}` })));
    response.data.results = users;
    return response;
});
exports.getCustomerUsers = getCustomerUsers;
//# sourceMappingURL=getCustomerUsers.js.map